<template>
  <div
    id="element"
    class="baniere"
  >
    <div class="bloc md:pt-20">
      <div class="w-full bloc2 md:flex justify-end">
        <div class="w-auto">
          <img
            src="../../../assets/icons/courbe.svg"
            alt=""
          >
        </div>
      </div>

      <div class="pt-10 md:flex retourPost">
        <div
          class="w-1/6 text-center md:block flex items-center"
          @click="goBack"
        >
          <div class="w-6">
            <svg-icon
              name="ic_back"
              class="md:h-10 h-6 cursor-pointer md:mr-0 mr-6 md:mt-0 mt-1"
              original
            />
          </div>
          <div class="page pl-2 md:mt-3">
            Carrière
          </div>
        </div>

        <div class="md:w-5/6 md:pl-6 pb-10 md:mt-0 mt-8">
          <div class="title w-full">
            {{ donnes.title }}
          </div>

          <div class="bloc1">
            <div class="detail">
              <span class="titre1">Lieu :</span> {{ donnes.place }}
            </div>
            <div class="detail">
              <span class="titre1">CDD :</span> {{ donnes.type }}
            </div>
            <div class="detail">
              <span class="titre1">Rénumération :</span> {{ donnes.paye }}
            </div>

            <divider
              :height="height"
              :color="color"
              class="mt-10"
            />

            <div class="mt-10">
              <div class="titre2">
                Description
              </div>
              <div class="description mt-2">
                {{ donnes.description }}
              </div>
            </div>

            <div class="mt-10">
              <div class="titre2">
                Responsabilité
              </div>
              <div
                class="description mt-2"
                v-html="donnes.responsabilite"
              />
            </div>

            <div class="mt-10">
              <div class="titre2">
                Pré-requis
              </div>
              <div
                class="description mt-2"
                v-html="donnes.prerequis"
              />
            </div>

            <div class="mt-10">
              <div class="titre2">
                Postuler à cette position
              </div>
              <div class="mt-2">
                <formulaire :donnes="donnes"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'
import formulaire from '@/components/cedo/carriere/form'

export default {
  name: 'Index',
  components: {
    divider,
    formulaire
  },
  props: {
    donnes: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      height: '1px',
      color: '#D3D9EB'
    }
  },
  created () {
    setTimeout(() => this.smooth(), 10)
  },
  methods: {
    goBack () {
      this.$emit('oga', false)
    },
    smooth () {
      let element = document.getElementById('element')
      // element.scrollIntoView(true)
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto;
   background-color: $fa;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .page{
    font-weight: normal;
    font-size: 18px;
    line-height: 160%;
    color: black;
  }

  .title{
    font-weight: normal;
    font-size: 48px;
    line-height: 160%;
    color: $black;
  }
  .titre1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 160%;
    color: black;
  }
  .titre2{
    font-weight: 800;
    font-size: 24px;
    line-height: 160%;
    color: black;
  }
  .description{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
  }
.bloc1{
  width: 80%;
}
  .bloc2{
    position: absolute;
    top: 100px;
    z-index: 1;
  }
  img{
    width: 944px;
    height: 983px;
  }
  .point{
    font-size: 30px;
    font-weight: bold;
    margin-right: 10px;
  }
  .retourPost{
    position: relative;
    z-index: 3;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .title{
      font-weight: 500;
      font-size: 32px;
    }
    .bloc1{
      width: 100%;
    }
    .bloc2{
      width: 100%;
      font-size: 18px;
    }
    .titre1, .description{
      font-size: 18px;
    }
    img{
      display: none;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre1{
      font-size: 20px;
    }
    .detail, .description{
      font-size: 20px;
    }
    .title{
      font-size: 32px;
    }
    .page{
      text-align: center;
    }
  }
</style>
